export enum ErrorFallback {
	CONTENT = "content",
	PAGE = "page",
}
